export enum EnumButtonAktionsTyp {
  MODALDIALOG_ABBRECHEN = 'ModalDialogAbbrechen',
  MODALDIALOG_SCHLIESSEN = 'ModalDialogSchliessen',
  ELEKTRONISCHUNTERSCHREIBEN_MOEGLICH = 'ElektronischeUnterschriftMoeglich',
  ELEKTRONISCHUNTERSCHREIBEN_NICHT_MOEGLICH = 'ElektronischeUnterschriftNichtMoeglich'
}
